webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0EZ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resources_TicketsResource__ = __webpack_require__("JNsJ");


var TicketsService = {
  ticketsResource: __WEBPACK_IMPORTED_MODULE_0__resources_TicketsResource__["a" /* default */],

  login: function login(user) {
    return this.ticketsResource.login(user);
  },

  loginWithSessionId: function loginWithSessionId(sessionId) {
    return this.ticketsResource.loginWithSessionId({ sessionId: sessionId });
  },

  loginWithAuthorization: function loginWithAuthorization(authorization) {
    return this.ticketsResource.loginWithAuthorization({ authorization: authorization });
  },

  findAllVehicles: function findAllVehicles() {
    return this.ticketsResource.findAllVehicles();
  },

  findAllIssueTypes: function findAllIssueTypes() {
    return this.ticketsResource.findAllIssueTypes();
  },

  createTickets: function createTickets(issues) {
    return this.ticketsResource.createTickets(issues);
  },

  createInternalTickets: function createInternalTickets(issues) {
    return this.ticketsResource.createInternalTickets(issues);
  },

  searchTickets: function searchTickets(filter) {
    return this.ticketsResource.searchTickets(filter);
  },

  exportTickets: function exportTickets(filter) {
    return this.ticketsResource.exportTickets(filter);
  },

  findTicketsSituations: function findTicketsSituations() {
    return this.ticketsResource.findTicketsSituations();
  },

  findVehiclesByPlate: function findVehiclesByPlate(plate) {
    return this.ticketsResource.findVehiclesByPlate({ plate: plate });
  },

  isPlatesInTickets: function isPlatesInTickets(plate) {
    return this.ticketsResource.isPlatesInTickets([plate]);
  },

  getDueDates: function getDueDates(links) {
    return this.ticketsResource.dueDates({ links: links });
  },

  findAllCustomers: function findAllCustomers() {
    return this.ticketsResource.findAllCustomers();
  },

  putOrganization: function putOrganization(organizationName) {
    return this.ticketsResource.putOrganization({ organizationName: organizationName });
  },

  findGeneralStatus: function findGeneralStatus() {
    return this.ticketsResource.findGeneralStatus();
  },

  searchOrganizations: function searchOrganizations(name) {
    return this.ticketsResource.searchOrganizations({ name: name });
  },

  findQuestionsByType: function findQuestionsByType(type) {
    return this.ticketsResource.findQuestionsByType({ type: type });
  },

  findCustomerName: function findCustomerName() {
    return this.ticketsResource.findCustomerName();
  },

  findLastCoordinate: function findLastCoordinate(vehicleId) {
    return this.ticketsResource.findLastCoordinate({ vehicleId: vehicleId });
  }

};

/* harmony default export */ __webpack_exports__["a"] = (TicketsService);

/***/ }),

/***/ "0PhT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_TicketsService__ = __webpack_require__("0EZ5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PieChart__ = __webpack_require__("g3cy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BarChart__ = __webpack_require__("rq5j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_datalabels__ = __webpack_require__("cNRp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_datalabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_datalabels__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      info: {
        openTickets: null,
        closedTickets: null,
        meanOpenTime: null,
        meanResolutionTime: null,
        openTicketsByOrganization: null,
        openTicketsByType: null
      },

      organizationBarOpt: {
        responsive: true,
        scales: {
          xAxes: [{
            barPercentage: 1.7
          }]
        },
        legend: {
          display: false,
          position: 'left'
        },
        title: {
          display: true,
          text: 'Chamados Abertos por Organização'
        }
      },
      organizationBarDatacollection: {
        datasets: null
      },

      typePieOpt: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'left'
        },
        title: {
          display: true,
          text: 'Chamados Abertos por Tipo'
        }
      },
      typePieDatacollection: {
        datasets: null
      }
    };
  },


  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_3__PieChart__["a" /* default */],
    BarChart: __WEBPACK_IMPORTED_MODULE_4__BarChart__["a" /* default */]
  },

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__services_TicketsService__["a" /* default */].findGeneralStatus().then(function (success) {
      _this.info = success.body;

      _this.info.meanOpenTime = Math.round(_this.info.meanOpenTime / 24);
      _this.info.meanResolutionTime = Math.round(_this.info.meanResolutionTime / 24);

      _this.mountOrganizationBarChart(_this.info);
      _this.mountTypePieChart(_this.info);
    });
  },


  methods: {
    mountOrganizationBarChart: function mountOrganizationBarChart(info) {
      var organizationTickets = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(info.openTicketsByOrganization);
      var organizationLabels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(info.openTicketsByOrganization);

      var colors = this.colorsByTicketCount(organizationTickets, 'rgba(26, 142, 35, {0})');

      this.organizationBarDatacollection = {
        labels: organizationLabels,
        datasets: [{
          label: '',
          backgroundColor: colors,
          data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(organizationTickets)
        }]
      };
    },

    mountTypePieChart: function mountTypePieChart(info) {
      var typeTickets = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(info.openTicketsByType);
      var typeLabels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(info.openTicketsByType);

      var colors = this.colorsByTicketCount(typeTickets, 'rgba(63, 63, 191, {0})');

      this.typePieDatacollection = {
        labels: typeLabels,
        datasets: [{
          label: '',
          backgroundColor: colors,
          data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(typeTickets),
          datalabels: {
            anchor: 'end'
          }
        }]
      };
    },

    colorsByTicketCount: function colorsByTicketCount(ticketCounts, colorTemplate) {

      if (!String.prototype.format) {
        String.prototype.format = function () {
          var formatted = this;
          for (var i = 0; i < arguments.length; i++) {
            var regexp = new RegExp('\\{' + i + '\\}', 'gi');
            formatted = formatted.replace(regexp, arguments[i]);
          }
          return formatted;
        };
      };

      var colors = [];
      var max = Math.max.apply(null, ticketCounts);
      var min = Math.min.apply(null, ticketCounts);

      ticketCounts.forEach(function (count) {
        var colorValue = (count - min) / (max - min);
        colorValue += 0.2;
        colors.push(colorTemplate.format(colorValue));
      });
      return colors;
    }

  }

});

/***/ }),

/***/ "1QwG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1cmR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full"},[_c('md-card',[_c('md-card-header',[_c('md-whiteframe',{staticClass:"md-medium",attrs:{"md-tag":"md-toolbar","md-elevation":"2"}},[_c('div',{staticClass:"md-toolbar-container"}),_vm._v(" "),_c('div',{staticClass:"md-toolbar-container"},[_c('h2',{staticClass:"md-title"},[_vm._v("Lista de Solicitações")]),_vm._v(" "),_c('md-button',{staticClass:"md-fab fab-export",on:{"click":function($event){return _vm.exportTickets()}}},[_c('md-icon',[_vm._v("cloud_download")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("Exportar Tickets")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-fab fab-filter",attrs:{"md-fab-trigger":""},on:{"click":function($event){return _vm.openFilter()}}},[_c('md-icon',[_vm._v("filter_list")]),_vm._v(" "),(_vm.isOpenFilter)?_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("Remover Filtro")]):_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("Filtrar")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":_vm.createTicketsPath}},[_c('md-button',{staticClass:"md-fab fab-new"},[_c('md-icon',[_vm._v("add")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("Criar Tickets")])],1)],1)],1)])],1),_vm._v(" "),_c('md-card-content',[(_vm.isOpenFilter)?_c('md-layout',{attrs:{"md-gutter":"16","mdFlex":"100"}},[_c('md-layout',{attrs:{"mdFlex":"22"}},[_c('md-input-container',[_c('label',[_vm._v("Código")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.filter.ticketKey),callback:function ($$v) {_vm.$set(_vm.filter, "ticketKey", $$v)},expression:"filter.ticketKey"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"mdFlex":"22"}},[_c('md-input-container',[_c('label',{attrs:{"for":"status"}},[_vm._v("Status")]),_vm._v(" "),_c('md-select',{attrs:{"name":"status","id":"status"},model:{value:(_vm.filter.situation),callback:function ($$v) {_vm.$set(_vm.filter, "situation", $$v)},expression:"filter.situation"}},_vm._l((_vm.situations),function(situation){return _c('md-option',{key:situation,attrs:{"value":situation}},[_vm._v(_vm._s(situation))])}),1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"mdFlex":"22"}},[_c('md-input-container',[_c('label',[_vm._v("Placa")]),_vm._v(" "),_c('md-autocomplete',{attrs:{"fetch":_vm.findVehiclesByPlateFetch,"print-attribute":'plate'},model:{value:(_vm.filter.vehiclePlate),callback:function ($$v) {_vm.$set(_vm.filter, "vehiclePlate", $$v)},expression:"filter.vehiclePlate"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"mdFlex":"23"}},[_c('md-input-container',[_c('label',[_vm._v("Organização")]),_vm._v(" "),_c('md-autocomplete',{attrs:{"fetch":_vm.findOrganizationsByNameFetch,"print-attribute":'name'},model:{value:(_vm.filter.organizationName),callback:function ($$v) {_vm.$set(_vm.filter, "organizationName", $$v)},expression:"filter.organizationName"}})],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"date-picker",attrs:{"mdFlex":"22"}},[_c('md-input-container',[_c('label',[_vm._v("Data de Criação")]),_vm._v(" "),_c('md-input',{attrs:{"value":_vm.getDateRangeFormated(_vm.filter.created)}})],1),_vm._v(" "),_c('date-picker',{attrs:{"range":""},on:{"change":_vm.updateState},model:{value:(_vm.filter.created),callback:function ($$v) {_vm.$set(_vm.filter, "created", $$v)},expression:"filter.created"}})],1),_vm._v(" "),_c('md-layout',{attrs:{"mdFlex":"5"}},[_c('md-button',{staticClass:"md-icon-button md-primary button-top",on:{"click":_vm.applyFilter}},[_c('md-icon',[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"mdFlex":"5"}},[_c('md-button',{staticClass:"md-icon-button md-primary button-top",on:{"click":_vm.clearFilter}},[_c('md-icon',[_vm._v("clear")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('md-layout',{staticClass:"scrolable grid",attrs:{"md-gutter":"16","mdFlex":"100"}},[_c('md-layout',{attrs:{"mdFlex":"100"}},[_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Código")]),_vm._v(" "),_c('md-table-head',[_vm._v("Data")]),_vm._v(" "),_c('md-table-head',[_vm._v("Placa")]),_vm._v(" "),_c('md-table-head',[_vm._v("Status")]),_vm._v(" "),_c('md-table-head',[_vm._v("Resolução")]),_vm._v(" "),_c('md-table-head',[_vm._v("Data de Resolução")]),_vm._v(" "),_c('md-table-head',[_vm._v("Tipo de Requisição")]),_vm._v(" "),_c('md-table-head',[_vm._v("Solicitante")]),_vm._v(" "),_c('md-table-head'),_vm._v(" "),_c('md-table-head'),_vm._v(" "),_c('md-table-head')],1)],1),_vm._v(" "),_c('md-table-body',[_vm._l((_vm.tickets),function(ticket){return _c('md-table-row',{key:ticket.key},[_c('md-table-cell',[_vm._v(_vm._s(ticket.key))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(ticket.fields.created))]),_vm._v(" "),(ticket.fields.customfield_10401)?_c('md-table-cell',[_vm._v(_vm._s(ticket.fields.customfield_10401[0]))]):_c('md-table-cell',[_vm._v("Não disponível")]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(ticket.fields.status.name))]),_vm._v(" "),(ticket.fields.resolution)?_c('md-table-cell',[_vm._v(_vm._s(ticket.fields.resolution.name))]):_c('md-table-cell',[_vm._v("Não disponível")]),_vm._v(" "),(ticket.fields.resolutiondate)?_c('md-table-cell',[_vm._v(_vm._s(ticket.fields.resolutiondate))]):_c('md-table-cell',[_vm._v("Não disponível")]),_vm._v(" "),(ticket.fields.customfield_10700)?_c('md-table-cell',[_vm._v(_vm._s(ticket.fields.customfield_10700.value))]):_c('md-table-cell',[_vm._v("Não disponível")]),_vm._v(" "),(ticket.fields.reporter)?_c('md-table-cell',[_vm._v(_vm._s(ticket.fields.reporter.name))]):_c('md-table-cell',[_vm._v("Não disponível")]),_vm._v(" "),_c('md-table-cell',[_c('div',[_c('md-button',{staticClass:"md-button md-primary",on:{"click":function($event){return _vm.showTicket(ticket)}}},[_vm._v("Ver")])],1)]),_vm._v(" "),_c('md-table-cell',[_c('div',[_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":'https://jira.trixlog.com/servicedesk/customer/portal/3/' +
                        ticket.key,"target":"_blank"}},[_c('md-icon',{staticClass:"md-primary"},[_vm._v("edit")])],1)])])],1)}),_vm._v(" "),_c('md-layout')],2)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"mdAlign":"center"}},[(_vm.isRequesting === true)?_c('md-spinner',{attrs:{"md-size":40,"md-indeterminate":""}}):_vm._e()],1),_vm._v(" "),_c('md-layout',{attrs:{"mdAlign":"center"}},[_c('md-button',{staticClass:"md-accent md-raised",on:{"click":_vm.findTickets}},[_vm._v("Carregar mais")])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"mdAlign":"end"}},[_vm._v(_vm._s(_vm.tickets.length)+" de "+_vm._s(_vm.ticketsNumber))])],1)],1),_vm._v(" "),_c('md-dialog',{ref:"ticketDetails",staticClass:"ticket-details-dialog"},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.seenTicket.fields.summary))]),_vm._v(" "),_c('md-dialog-content',[_c('div',{staticClass:"md-card-row"},[_c('div',{staticClass:"md-card-column-first"},[_c('div',{staticClass:"md-card-row"},[_c('div',{staticClass:"md-card-column-first"},[_c('md-input-container',[_c('label',[_vm._v("Aberto em")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.fields.created),callback:function ($$v) {_vm.$set(_vm.seenTicket.fields, "created", $$v)},expression:"seenTicket.fields.created"}})],1),_vm._v(" "),(_vm.seenTicket.fields.customfield_10401)?_c('md-input-container',[_c('label',[_vm._v("Placa")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.fields.customfield_10401[0]),callback:function ($$v) {_vm.$set(_vm.seenTicket.fields.customfield_10401, 0, $$v)},expression:"seenTicket.fields.customfield_10401[0]"}})],1):_vm._e(),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Status")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.fields.status.name),callback:function ($$v) {_vm.$set(_vm.seenTicket.fields.status, "name", $$v)},expression:"seenTicket.fields.status.name"}})],1),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Previsão de configuração")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.linksStatus.configurationStatus),callback:function ($$v) {_vm.$set(_vm.linksStatus, "configurationStatus", $$v)},expression:"linksStatus.configurationStatus"}})],1),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Previsão de expedição")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.linksStatus.expeditionStatus),callback:function ($$v) {_vm.$set(_vm.linksStatus, "expeditionStatus", $$v)},expression:"linksStatus.expeditionStatus"}})],1),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Está dentro do SLA?")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.inSLA),callback:function ($$v) {_vm.$set(_vm.seenTicket, "inSLA", $$v)},expression:"seenTicket.inSLA"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"md-card-column-last"},[_c('md-input-container',[_c('label',[_vm._v("Descrição")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.fields.description),callback:function ($$v) {_vm.$set(_vm.seenTicket.fields, "description", $$v)},expression:"seenTicket.fields.description"}})],1),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Data de Criação")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.create_date),callback:function ($$v) {_vm.$set(_vm.seenTicket, "create_date", $$v)},expression:"seenTicket.create_date"}})],1),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Data da Atualização")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.updated),callback:function ($$v) {_vm.$set(_vm.seenTicket, "updated", $$v)},expression:"seenTicket.updated"}})],1),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Data da Expedição")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.expedir_duedate),callback:function ($$v) {_vm.$set(_vm.seenTicket, "expedir_duedate", $$v)},expression:"seenTicket.expedir_duedate"}})],1),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Resolução")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.resolution),callback:function ($$v) {_vm.$set(_vm.seenTicket, "resolution", $$v)},expression:"seenTicket.resolution"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"md-card-column-last"},[_c('div',{staticClass:"md-card-row"},[_c('div',{staticClass:"md-card-column-first"},[_c('md-input-container',[_c('label',[_vm._v("Data da Resolução")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.resolution_date),callback:function ($$v) {_vm.$set(_vm.seenTicket, "resolution_date", $$v)},expression:"seenTicket.resolution_date"}})],1),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Solicitante")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.requester),callback:function ($$v) {_vm.$set(_vm.seenTicket, "requester", $$v)},expression:"seenTicket.requester"}})],1),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Categoria do Projeto")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.project_category),callback:function ($$v) {_vm.$set(_vm.seenTicket, "project_category", $$v)},expression:"seenTicket.project_category"}})],1),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Tipo de Solicitação")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.request_type),callback:function ($$v) {_vm.$set(_vm.seenTicket, "request_type", $$v)},expression:"seenTicket.request_type"}})],1),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Tipo de Serviço")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.service_type),callback:function ($$v) {_vm.$set(_vm.seenTicket, "service_type", $$v)},expression:"seenTicket.service_type"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"md-card-column-last"},[_c('md-input-container',[_c('label',[_vm._v("Questão Preventiva")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.preventive_issue),callback:function ($$v) {_vm.$set(_vm.seenTicket, "preventive_issue", $$v)},expression:"seenTicket.preventive_issue"}})],1),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Setor")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.sector),callback:function ($$v) {_vm.$set(_vm.seenTicket, "sector", $$v)},expression:"seenTicket.sector"}})],1),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Dias no setor")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.days_in_sector),callback:function ($$v) {_vm.$set(_vm.seenTicket, "days_in_sector", $$v)},expression:"seenTicket.days_in_sector"}})],1),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Filial")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.branch_argos),callback:function ($$v) {_vm.$set(_vm.seenTicket, "branch_argos", $$v)},expression:"seenTicket.branch_argos"}})],1),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Capital")]),_vm._v(" "),_c('md-input',{attrs:{"readonly":""},model:{value:(_vm.seenTicket.capital),callback:function ($$v) {_vm.$set(_vm.seenTicket, "capital", $$v)},expression:"seenTicket.capital"}})],1)],1)])])]),_vm._v(" "),_c('div'),_vm._v(" "),(_vm.seenTicket.hasScheduling)?_c('div',[_c('h3',[_vm._v("Histórico")]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Criação")]),_vm._v(" "),_c('md-table-head',[_vm._v("Primeira Data de Disponibilidade")]),_vm._v(" "),_c('md-table-head',[_vm._v("Datas Seguintes")]),_vm._v(" "),_c('md-table-head',[_vm._v("Data de Agendamento")]),_vm._v(" "),_c('md-table-head',[_vm._v("Status de Reprogramação")]),_vm._v(" "),_c('md-table-head',[_vm._v("Responsável")]),_vm._v(" "),_c('md-table-head',[_vm._v("Responsabilidade do Agendamento")]),_vm._v(" "),_c('md-table-head',[_vm._v("Data informada pelo Cliente")]),_vm._v(" "),_c('md-table-head',[_vm._v("Detalhes")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.seenTicket.scheduling_flows),function(scheduling,index){return _c('md-table-row',{key:index},[_c('md-table-cell',[_vm._v(_vm._s(_vm.getDateFormated(scheduling.created)))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(_vm.getDateFormated(scheduling.first_availability_date)))]),_vm._v(" "),_c('md-table-cell',_vm._l((scheduling.following_dates),function(date,index){return _c('span',{key:index},[_vm._v("\n                "+_vm._s(_vm.getDateFormated(date))+"\n              ")])}),0),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(_vm.getDateFormated(scheduling.schedule_date)))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(scheduling.rescheduling_status))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(scheduling.responsible))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(scheduling.schedule_responsible))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(_vm.getDateFormated(scheduling.client_date)))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(scheduling.details))])],1)}),1)],1)],1):_vm._e()]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){return _vm.closeShowTicketDialog()}}},[_vm._v("Ok")])],1)],1),_vm._v(" "),_c('md-dialog',{ref:"wait",attrs:{"md-open-from":"#wait","md-close-to":"#wait"}},[_c('md-dialog-title',[_vm._v("Aguarde ...")]),_vm._v(" "),_c('md-dialog-content',[_c('md-progress',{attrs:{"md-indeterminate":""}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6VXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-toolbar',[_c('h2',{staticClass:"md-title",staticStyle:{"flex":"1"}},[_vm._v("Tickets")]),_vm._v(" "),_c('md-menu',{attrs:{"md-align-trigger":""}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("arrow_drop_down")])],1),_vm._v(" "),_c('md-menu-content',[_c('md-menu-item',{on:{"click":_vm.logout}},[_vm._v("Logout")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"space"}),_vm._v(" "),_c('md-layout',{attrs:{"mdAlign":"center","mdGutter":"16"}},[_c('md-layout',{attrs:{"mdFlex":"75"}},[_c('md-layout',{attrs:{"mdColumn":""}},[_c('md-layout',{attrs:{"mdFlex":"75"}},[_c('router-view')],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AaX6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({

  getLoginInfo: function getLoginInfo() {
    return JSON.parse(localStorage.getItem("loginInfo"));
  },

  setLoginInfo: function setLoginInfo(loginInfo) {
    localStorage.setItem("loginInfo", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(loginInfo));
  },

  removeLoginInfo: function removeLoginInfo() {
    return localStorage.removeItem("loginInfo");
  }

});

/***/ }),

/***/ "IfRl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_TicketsService__ = __webpack_require__("0EZ5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_AuthService__ = __webpack_require__("SGRL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_LocalMessageService__ = __webpack_require__("an13");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {

      selectedCustomer: null,

      customers: [],

      snack: {
        vertical: 'bottom',
        horizontal: 'center',
        duration: 6000,
        message: null
      },

      authToken: null
    };
  },
  created: function created() {
    this.authToken = __WEBPACK_IMPORTED_MODULE_1__services_AuthService__["a" /* default */].getToken();
    __WEBPACK_IMPORTED_MODULE_1__services_AuthService__["a" /* default */].removeToken();
    this.findAllCustomers();
  },


  methods: {

    findAllCustomers: function findAllCustomers() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_TicketsService__["a" /* default */].findAllCustomers().then(function (success) {
        _this.customers = success.body;
      });
    },

    putOrganization: function putOrganization(organizationName) {
      var _this2 = this;

      if (organizationName) {
        __WEBPACK_IMPORTED_MODULE_0__services_TicketsService__["a" /* default */].putOrganization(organizationName).then(function (success) {
          __WEBPACK_IMPORTED_MODULE_1__services_AuthService__["a" /* default */].addToken(_this2.authToken);
          __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push({ path: '/' });
        }, function (error) {
          __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push({ path: '/login' });
        });
      }
    }

  }

});

/***/ }),

/***/ "JNsJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Url_js__ = __webpack_require__("m78x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__("8+8L");




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

var TicketActions = {
  login: { method: 'POST', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/login' },

  loginWithSessionId: { method: 'GET', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/login{/sessionId}' },

  loginWithAuthorization: { method: 'GET', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/auth{/authorization}' },

  findAllVehicles: { method: 'GET', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/vehicles' },

  findAllIssueTypes: { method: 'GET', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/issueTypes' },

  createTickets: { method: 'POST', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/createTickets' },

  createInternalTickets: { method: 'POST', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/internal/createTickets' },

  searchTickets: { method: 'POST', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/search' },

  exportTickets: { method: 'POST', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/export' },

  findTicketsSituations: { method: 'GET', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/situation' },

  findVehiclesByPlate: { method: 'GET', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/vehicles/search{/plate}' },

  isPlatesInTickets: { method: 'POST', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/isPlatesInTickets' },

  findAllCustomers: { method: 'GET', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/customer' },

  putOrganization: { method: 'GET', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/customer{/organizationName}' },

  findGeneralStatus: { method: 'GET', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/generalStatus' },

  searchOrganizations: { method: 'GET', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/organization/search{/name}' },

  findQuestionsByType: { method: 'GET', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/questions{/type}' },

  findCustomerName: { method: 'GET', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/customer' },

  findLastCoordinate: { method: 'GET', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/transmission/last{/vehicleId}' },

  dueDates: { method: 'GET', url: __WEBPACK_IMPORTED_MODULE_0__Url_js__["a" /* default */].baseUrl + '/dueDates' }
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue__["default"].resource('', {}, TicketActions));

/***/ }),

/***/ "JVne":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondStepLogin_vue__ = __webpack_require__("IfRl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a1af736_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondStepLogin_vue__ = __webpack_require__("h5Mi");
function injectStyle (ssrContext) {
  __webpack_require__("Luwy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondStepLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a1af736_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondStepLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kn27":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full"},[_c('md-card',[_c('md-card-header',[_c('md-whiteframe',{staticClass:"md-medium",attrs:{"md-tag":"md-toolbar","md-elevation":"2"}},[_c('div',{staticClass:"md-toolbar-container"},[_c('h2',{staticClass:"md-title"},[_vm._v("Dashboard")])])])],1),_vm._v(" "),_c('md-card-content',{staticClass:"scrolable"},[_c('md-layout',{attrs:{"md-gutter":16}},[_c('md-layout',{attrs:{"md-flex":"25"}},[_c('md-card',{staticClass:"full-width card-spacing"},[_c('md-card-header',[_c('md-card-header-text',[_c('h4',[_vm._v("Chamados Abertos")])])],1),_vm._v(" "),_c('md-card-content',{staticClass:"md-card-info-content"},[_c('span',{staticClass:"content-text"},[_vm._v(_vm._s(_vm.info.openTickets))])])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"25"}},[_c('md-card',{staticClass:"full-width card-spacing"},[_c('md-card-header',[_c('md-card-header-text',[_c('h4',[_vm._v("Chamados Concluídos")])])],1),_vm._v(" "),_c('md-card-content',[_c('span',{staticClass:"content-text"},[_vm._v(" "+_vm._s(_vm.info.closedTickets)+" ")])])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"25"}},[_c('md-card',{staticClass:"full-width card-spacing"},[_c('md-card-header',[_c('md-card-header-text',[_c('h4',[_vm._v("Tempo Médio de Chamados Abertos")])])],1),_vm._v(" "),_c('md-card-content',[(_vm.info.meanOpenTime)?_c('span',{staticClass:"content-text"},[_vm._v(" "+_vm._s(_vm.info.meanOpenTime)+" dias ")]):_vm._e()])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"25"}},[_c('md-card',{staticClass:"full-width card-spacing"},[_c('md-card-header',[_c('md-card-header-text',[_c('h4',[_vm._v("Tempo Médio de Resolução")])])],1),_vm._v(" "),_c('md-card-content',[(_vm.info.meanResolutionTime)?_c('span',{staticClass:"content-text"},[_vm._v(" "+_vm._s(_vm.info.meanResolutionTime)+" dias ")]):_vm._e()])],1)],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"top-spacing",attrs:{"md-gutter":16}},[_c('md-layout',{attrs:{"md-flex":"100"}},[_c('md-card',{staticClass:"full"},[_c('md-card-content',{staticClass:"md-card-graph-content"},[_c('BarChart',{attrs:{"chart-data":_vm.organizationBarDatacollection,"options":_vm.organizationBarOpt,"width":800,"height":220}})],1)],1)],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"top-spacing",attrs:{"md-gutter":16}},[_c('md-layout',[_c('md-card',{staticClass:"full"},[_c('md-card-content',{staticClass:"md-card-graph-content"},[_c('PieChart',{attrs:{"chart-data":_vm.typePieDatacollection,"options":_vm.typePieOpt,"width":200,"height":200}})],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Luwy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_809f3b5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("j2Eq");
function injectStyle (ssrContext) {
  __webpack_require__("SNGw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_809f3b5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mq8e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css__ = __webpack_require__("tzNG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_app_css__ = __webpack_require__("RhQv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_app_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_app_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material__ = __webpack_require__("Lgyv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_session__ = __webpack_require__("18Sv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_AuthService__ = __webpack_require__("SGRL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_LocalMessageService__ = __webpack_require__("an13");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_material___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.credentials = true;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {

  next(function (response) {
    if (response.status === 401) {
      __WEBPACK_IMPORTED_MODULE_8__services_AuthService__["a" /* default */].removeToken();
      __WEBPACK_IMPORTED_MODULE_9__services_LocalMessageService__["a" /* default */].setLocalMessage("Sua sessão expirou! Faça login novamente!");
      __WEBPACK_IMPORTED_MODULE_7__router_index__["a" /* default */].push({ path: '/login' });
    }
  });
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].material.registerTheme('default', {
  primary: {
    color: 'teal',
    hue: '400',
    textColor: 'white'
  },
  accent: {
    color: 'teal',
    hue: 'A400'
  },
  warn: {
    color: 'red',
    hue: '400'
  },
  background: 'white'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].material.inkRipple = true;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router_index__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "NXZ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_TicketsService__ = __webpack_require__("0EZ5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_AuthService__ = __webpack_require__("SGRL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debounce__ = __webpack_require__("HhAh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debounce__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      issues: {
        created: null,
        description: null,
        summaryFormat: "%customer% - %plate%",
        vehicleTickets: [{ serial: null, plate: null, issuetype: null }],
        summaryOptions: {
          "%plate%": "Placa",
          "%code%": "Código",
          "%organization%": "Organização",
          "%customer%": "Cliente"
        }
      },

      issueTypes: ["(Des)instalação/Remanejamento", "Falha no equipamento", "Falha de transmissão", "Cadastros no sistema", "Dúvida Geral", "Outros"],

      vehicles: [],

      lastSelected: null,
      snack: {
        vertical: 'bottom',
        horizontal: 'center',
        duration: 4000,
        message: null
      },

      exampleSummary: {
        message: null,
        "%plate%": "PPP-9999",
        "%organization%": "Organização X",
        "%customer%": "Cliente Y",
        "%code%": "COD12"
      }
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0_moment_moment___default.a.locale('pt-br');
    this.issues.created = __WEBPACK_IMPORTED_MODULE_0_moment_moment___default()().format('L');
  },


  methods: {
    filter: function filter(list, string) {
      console.log(list);
      return function () {
        return list;
      };
    },


    addVehicle: function addVehicle() {
      this.issues.vehicleTickets.push({ plate: null, issuetype: this.lastSelected });
    },

    removeVehicle: function removeVehicle(vehicleTicket) {
      var i = this.issues.vehicleTickets.indexOf(vehicleTicket);
      this.issues.vehicleTickets.splice(i, 1);
    },

    filterVehicles: function filterVehicles(vehicles, plate) {
      return function () {
        var v = vehicles.filter(function (vehicle) {
          return vehicle.plate.toLowerCase().indexOf(plate.toLowerCase()) !== -1;
        });
        return v;
      };
    },

    findVehiclesByPlateFetch: function findVehiclesByPlateFetch(query) {
      var _this = this;

      if (query.q && query.q !== "") {
        return __WEBPACK_IMPORTED_MODULE_1__services_TicketsService__["a" /* default */].findVehiclesByPlate(query.q).then(function (success) {
          if (success.body.length === 1) {
            _this.isPlatesInTickets(success.body[0], success.body[0].plate);
            return [];
          }
          return success.body;
        });
      }
    },

    isPlatesInTickets: function isPlatesInTickets(vehicle, plate) {
      var _this2 = this;

      this.issues.vehicleTickets.forEach(function (vehicleTicket) {
        if (vehicleTicket.plate.toUpperCase() === plate.toUpperCase()) {
          vehicleTicket.code = vehicle.code;
          vehicleTicket.equipment = vehicle.equipment;
          vehicleTicket.organization = vehicle.organization;
          vehicleTicket.hasPlateError = false;
          vehicleTicket.messageError = "";
        }
      });
      vehicle.hasPlateError = false;
      vehicle.messageError = "";
      __WEBPACK_IMPORTED_MODULE_1__services_TicketsService__["a" /* default */].isPlatesInTickets(plate).then(function (success) {}, function (error) {
        _this2.issues.vehicleTickets.forEach(function (vehicleTicket) {
          if (vehicleTicket.plate === plate) {
            vehicleTicket.hasPlateError = true;
            vehicleTicket.messageError = error.bodyText;
          }
        });
        vehicle.hasPlateError = true;
        vehicle.messageError = error.bodyText;
        _this2.snack.message = error.bodyText;
        _this2.openSnack();
      });
    },

    validateTickets: function validateTickets() {
      if (!this.issues.description || this.issues.description === '') {
        this.issues.hasDescriptionError = true;
        this.snack.message = 'O campo descrição não pode ser vazio';
        this.openSnack();
        return false;
      }
      if (this.issues.vehicleTickets.length === 0) {
        this.snack.message = 'Selecione ao menos um veículo';
        this.openSnack();
        return false;
      }
      var i;
      for (i in this.issues.vehicleTickets) {
        if (this.issues.vehicleTickets[i].hasPlateError === true) {
          this.snack.message = 'Remova as placas que já possuem Tickets abertos';
          this.openSnack();
          return false;
        }
        if (!this.issues.vehicleTickets[i].plate || this.issues.vehicleTickets[i].plate === '') {
          this.issues.vehicleTickets[i].hasPlateError = true;
          this.snack.message = 'Selecione um veículo ou remova o ticket';
          this.openSnack();
          return false;
        }
        if (!this.issues.vehicleTickets[i].issuetype) {
          this.issues.vehicleTickets[i].hasIssuetypeError = true;
          this.snack.message = 'Selecione um motivo para cada placa';
          this.openSnack();
          return false;
        }
      }
      return true;
    },

    saveTickets: function saveTickets() {
      var _this3 = this;

      var isValid = this.validateTickets();
      this.closeSaveDialog();
      if (isValid === true) {
        this.openWaitDialog();
        __WEBPACK_IMPORTED_MODULE_1__services_TicketsService__["a" /* default */].createInternalTickets(this.issues).then(function (success) {
          __WEBPACK_IMPORTED_MODULE_4__router_index__["a" /* default */].push({ path: '/' });
        }, function (failure) {
          _this3.closeWaitDialog();
          _this3.snack.message = failure.bodyText;
          _this3.openSnack();
        });
      }
    },

    updateLastSelected: function updateLastSelected(selected) {
      this.lastSelected = selected;
    },

    openSnack: function openSnack() {
      this.$refs.snackbar.close();
      this.$refs.snackbar.open();
    },

    openWaitDialog: function openWaitDialog() {
      this.$refs.wait.open();
    },

    closeWaitDialog: function closeWaitDialog() {
      this.$refs.wait.close();
    },

    openSaveDialog: function openSaveDialog() {
      this.$refs.save.open();
    },

    closeSaveDialog: function closeSaveDialog() {
      this.$refs.save.close();
    },

    insertKeyOnSummary: function insertKeyOnSummary(key) {
      this.issues.summaryFormat = this.issues.summaryFormat + " " + key;
    }
  },

  computed: {
    exampleMessage: function exampleMessage() {
      this.exampleSummary.message = this.issues.summaryFormat;

      for (var sampleKey in this.exampleSummary) {
        this.exampleSummary.message = this.exampleSummary.message.replace(new RegExp(sampleKey, 'g'), this.exampleSummary[sampleKey]);
      }
      return this.exampleSummary.message;
    }
  }

});

/***/ }),

/***/ "RhQv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S6Wj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SGRL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getAuthHeader: function getAuthHeader() {
    return "Basic " + this.getToken();
  },

  getToken: function getToken() {
    return localStorage.getItem("token");
  },

  createToken: function createToken(user) {
    var token = btoa(user.username + ":" + user.password);
    this.addToken(token);
  },

  addToken: function addToken(token) {
    localStorage.setItem("token", token);
  },

  removeToken: function removeToken() {
    return localStorage.removeItem("token");
  }

});

/***/ }),

/***/ "SNGw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UPcg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XT1e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketsDashboard_vue__ = __webpack_require__("0PhT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_261a13bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketsDashboard_vue__ = __webpack_require__("Kn27");
function injectStyle (ssrContext) {
  __webpack_require__("Mq8e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketsDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_261a13bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketsDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y2Jh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_TicketsService__ = __webpack_require__("0EZ5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.findCustomerName();
  },
  data: function data() {
    return {
      customerName: null,
      ticketsInfo: {
        created: null,
        description: null,
        ticketType: null,
        vehicleTickets: [{ serial: null, plate: null, organization: { name: null } }],
        questionsResponses: {},
        lastCoordinate: {
          coordinateDate: null,
          lastTransmissionTime: null
        }
      },

      adictionalQuestions: {
        ticketType: null,
        fields: null
      },

      ticketTypes: {
        "INSTALL_UNINSTALL": "(Des)instalação/Remanejamento",
        "EQUIPMENT_FAIL": "Falha no equipamento",
        "TRANSMISSION_FAIL": "Falha de transmissão",
        "RFID": "Falha no leitor RFID",
        "SYSTEM_REGISTER": "Cadastros no sistema",
        "GENERAL_DOUBT": "Dúvida Geral",
        "OTHERS": "Outros"
      },

      snack: {
        vertical: 'bottom',
        horizontal: 'center',
        duration: Infinity,
        message: null
      },
      isRequesting: false
    };
  },


  methods: {
    saveTickets: function saveTickets() {
      var _this = this;

      var isValid = this.validateTickets();
      this.closeSaveDialog();
      if (isValid === true) {
        this.openWaitDialog();
        __WEBPACK_IMPORTED_MODULE_1__services_TicketsService__["a" /* default */].createTickets(this.ticketsInfo).then(function (success) {
          _this.closeWaitDialog();
          location.reload();
        }, function (failure) {
          _this.closeWaitDialog();
          _this.snack.message = failure.bodyText;
          _this.openSnack();
        });
      }
    },

    hasBooleanQuestion: function hasBooleanQuestion() {
      var boolFields = this.getFieldsByType(this.adictionalQuestions.fields, 'BOOLEAN');
      return boolFields.length > 0;
    },
    hasStringQuestion: function hasStringQuestion() {
      var stringFields = this.getFieldsByType(this.adictionalQuestions.fields, 'STRING');
      return stringFields.length > 0;
    },
    hasFileQuestion: function hasFileQuestion() {
      var fileFields = this.getFieldsByType(this.adictionalQuestions.fields, 'FILE');
      return fileFields.length > 0;
    },
    findQuestionsByType: function findQuestionsByType(type) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_TicketsService__["a" /* default */].findQuestionsByType(type).then(function (success) {
        _this2.ticketsInfo.questionsResponses = {};

        if (success.body.fields) {
          success.body.fields.forEach(function (field, i, array) {
            _this2.ticketsInfo.questionsResponses[field.name] = null;
          });
        }

        _this2.adictionalQuestions = success.body;
      });
    },
    isWrongResponse: function isWrongResponse(field) {
      if (field.correctValue !== null && this.ticketsInfo.questionsResponses[field.name] !== null) {
        if (field.correctValue !== this.ticketsInfo.questionsResponses[field.name]) {
          this.snack.message = field.wrongValueMessage;
          this.openSnack();
        }
      }
    },
    findVehiclesByPlateFetch: function findVehiclesByPlateFetch(query) {
      var _this3 = this;

      if (query.q && query.q !== "") {
        this.isRequesting = true;
        return __WEBPACK_IMPORTED_MODULE_1__services_TicketsService__["a" /* default */].findVehiclesByPlate(query.q).then(function (success) {
          _this3.isRequesting = false;
          if (success.body.length === 1) {
            _this3.isPlatesInTickets(success.body[0], success.body[0].plate);
            return [];
          }
          return success.body;
        });
      }
    },
    findOrganizationByNameFetch: function findOrganizationByNameFetch(query) {
      var _this4 = this;

      if (query.q && query.q !== "") {
        this.isRequesting = true;
        return __WEBPACK_IMPORTED_MODULE_1__services_TicketsService__["a" /* default */].searchOrganizations(query.q).then(function (success) {
          _this4.isRequesting = true;
          return success.body;
        });
      }
    },
    getFieldsByType: function getFieldsByType(fields, type) {
      if (fields) {
        return fields.filter(function (field, i, array) {
          return field.type === type;
        });
      }
      return [];
    },
    encodeFile: function encodeFile(files, fieldName) {
      var _this5 = this;

      var reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = function () {
        _this5.ticketsInfo.questionsResponses[fieldName] = reader.result.split("base64,")[1];
      };
    },


    isPlatesInTickets: function isPlatesInTickets(vehicle, plate) {
      var _this6 = this;

      this.ticketsInfo.vehicleTickets.forEach(function (vehicleTicket) {
        if (vehicleTicket.plate.toUpperCase() === plate.toUpperCase()) {
          vehicleTicket.code = vehicle.code;
          vehicleTicket.equipment = vehicle.equipment;
          vehicleTicket.organization = vehicle.organization;
          vehicleTicket.hasPlateError = false;
          vehicleTicket.messageError = "";
        }
      });
      vehicle.hasPlateError = false;
      vehicle.messageError = "";
      this.findLastCoordinate(vehicle.id);
      __WEBPACK_IMPORTED_MODULE_1__services_TicketsService__["a" /* default */].isPlatesInTickets(plate).then(function (success) {}, function (error) {
        _this6.ticketsInfo.vehicleTickets.forEach(function (vehicleTicket) {
          if (vehicleTicket.plate === plate) {
            vehicleTicket.hasPlateError = true;
            vehicleTicket.messageError = error.bodyText;
          }
        });
        vehicle.hasPlateError = true;
        vehicle.messageError = error.bodyText;
        _this6.snack.message = error.bodyText;
        _this6.openSnack();
      });
    },

    findLastCoordinate: function findLastCoordinate(vehicleId) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_TicketsService__["a" /* default */].findLastCoordinate(vehicleId).then(function (success) {
        _this7.ticketsInfo.lastCoordinate = success.body;
      });
    },


    validateTickets: function validateTickets() {
      if (!this.ticketsInfo.ticketType || this.ticketsInfo.ticketType === '') {
        this.ticketsInfo.hasTicketTypeError = true;
        this.snack.message = 'O campo motivo não pode ser vazio';
        this.openSnack();
        return false;
      }
      if (!this.ticketsInfo.description || this.ticketsInfo.description === '') {
        this.ticketsInfo.hasDescriptionError = true;
        this.snack.message = 'O campo descrição não pode ser vazio';
        this.openSnack();
        return false;
      }
      if (this.ticketsInfo.vehicleTickets.length === 0 || !this.ticketsInfo.vehicleTickets[0].plate || this.ticketsInfo.vehicleTickets[0].plate === '') {
        this.snack.message = 'Selecione ao menos um veículo';
        this.openSnack();
        return false;
      }

      if (this.adictionalQuestions.fields) {
        if (this.ticketsInfo.ticketType === 'TRANSMISSION_FAIL') {
          if (this.ticketsInfo.lastCoordinate.lastTransmissionTime !== null && this.ticketsInfo.lastCoordinate.lastTransmissionTime < 36) {
            this.snack.message = 'O veículo selecionado transmitiu nas últimas 36 horas';
            this.openSnack();
            return false;
          }
        }

        var i;
        for (i in this.adictionalQuestions.fields) {
          var field = this.adictionalQuestions.fields[i];
          if (this.ticketsInfo.questionsResponses[field.name] === null) {
            this.snack.message = 'Todas as informações adicionais devem ser respondidas';
            this.openSnack();
            return false;
          }
        }
      }

      var i;
      for (i in this.ticketsInfo.vehicleTickets) {
        if (this.ticketsInfo.vehicleTickets[i].hasPlateError === true) {
          this.snack.message = 'Remova as placas que já possuem Tickets abertos';
          this.openSnack();
          return false;
        }
        if (!this.ticketsInfo.vehicleTickets[i].plate || this.ticketsInfo.vehicleTickets[i].plate === '') {
          this.ticketsInfo.vehicleTickets[i].hasPlateError = true;
          this.snack.message = 'Selecione um veículo ou remova o ticket';
          this.openSnack();
          return false;
        }
        if (!this.ticketsInfo.vehicleTickets[i].organization.name || this.ticketsInfo.vehicleTickets[i].organization.name === '') {
          this.ticketsInfo.vehicleTickets[i].hasOrganizationError = true;
          this.snack.message = 'Selecione uma organização para cada placa';
          this.openSnack();
          return false;
        }
      }
      return true;
    },

    findCustomerName: function findCustomerName() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_TicketsService__["a" /* default */].findCustomerName().then(function (success) {
        _this8.customerName = success.bodyText;
      });
    },

    openSnack: function openSnack() {
      this.$refs.snackbar.open();
    },

    closeSnack: function closeSnack() {
      this.$refs.snackbar.close();
    },

    addVehicle: function addVehicle() {
      this.ticketsInfo.vehicleTickets.push({ plate: null, organization: { name: null } });
    },

    removeVehicle: function removeVehicle(vehicleTicket) {
      var i = this.ticketsInfo.vehicleTickets.indexOf(vehicleTicket);
      this.ticketsInfo.vehicleTickets.splice(i, 1);
    },

    openWaitDialog: function openWaitDialog() {
      this.$refs.wait.open();
    },

    closeWaitDialog: function closeWaitDialog() {
      this.$refs.wait.close();
    },

    openSaveDialog: function openSaveDialog() {
      this.$refs.save.open();
    },

    closeSaveDialog: function closeSaveDialog() {
      this.$refs.save.close();
    }

  },

  computed: {
    formattedSummary: function formattedSummary() {
      var summary = this.customerName ? this.customerName.toUpperCase() : '';
      var vehiclesLen = this.ticketsInfo.vehicleTickets.length;

      if (vehiclesLen == 0) {
        summary += " - Nenhum veículo - Nenhuma organização";
      } else if (vehiclesLen == 1) {
        var organizationName = this.ticketsInfo.vehicleTickets[0].organization.name;
        var plate = this.ticketsInfo.vehicleTickets[0].plate;

        organizationName = organizationName ? organizationName.toUpperCase() : null;
        plate = plate ? plate.toUpperCase() : null;
        if (plate && organizationName) {
          summary += " - " + organizationName + " - " + plate;
        } else if (organizationName) {
          summary += " - " + organizationName;
        } else if (plate) {
          summary += " - " + plate;
        }
      } else {
        summary += " - " + vehiclesLen + " Organizações - " + vehiclesLen + " Veículos";
      }

      return summary;
    }

  }

});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TicketsList_vue__ = __webpack_require__("yoAV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CreateTickets_vue__ = __webpack_require__("fPnO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CreateTicketsV2_vue__ = __webpack_require__("aMdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Login_vue__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SecondStepLogin_vue__ = __webpack_require__("JVne");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_AuthService__ = __webpack_require__("SGRL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TicketsDashboard_vue__ = __webpack_require__("XT1e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_LoginInfoService__ = __webpack_require__("AaX6");











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/tickets'
  }, {
    path: '/tickets',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_TicketsList_vue__["a" /* default */]
  }, {
    path: '/create_tickets',
    name: 'Create Tickets',
    component: __WEBPACK_IMPORTED_MODULE_4__components_CreateTicketsV2_vue__["a" /* default */]
  }, {
    path: '/create_tickets_internal',
    name: 'Create Tickets Internal',
    component: __WEBPACK_IMPORTED_MODULE_3__components_CreateTickets_vue__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Login_vue__["a" /* default */]
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_8__components_TicketsDashboard_vue__["a" /* default */]
  }, {
    path: '/second_step_login',
    name: 'Second Step Login',
    component: __WEBPACK_IMPORTED_MODULE_6__components_SecondStepLogin_vue__["a" /* default */]
  }]
});

var permitedPages = ['/login'];

router.beforeEach(function (to, from, next) {
  var token = __WEBPACK_IMPORTED_MODULE_7__services_AuthService__["a" /* default */].getToken();
  if (to.path === '/tickets' && (to.query.sessionid || to.query.authorization)) {
    next();
    return;
  }
  if (permitedPages.includes(to.path)) {
    next();
    return;
  }

  var loginInfo = __WEBPACK_IMPORTED_MODULE_9__services_LoginInfoService__["a" /* default */].getLoginInfo();
  if (to.path === '/create_tickets' && loginInfo.internal === true) {
    next('/create_tickets_internal');
    return;
  }
  if (to.path === '/create_tickets_internal' && loginInfo.internal === false) {
    next('/create_tickets');
    return;
  }
  if (token) {
    next();
  } else {
    next('/login');
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "ZgbO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aAZX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aMdI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateTicketsV2_vue__ = __webpack_require__("Y2Jh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76c0f5d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateTicketsV2_vue__ = __webpack_require__("qJBO");
function injectStyle (ssrContext) {
  __webpack_require__("sgCA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateTicketsV2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76c0f5d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateTicketsV2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aRa1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-layout',{attrs:{"mdAlign":"center"}},[_c('div',{staticClass:"half"},[_c('md-card',[_c('md-card-header',[_c('md-whiteframe',{staticClass:"md-medium",attrs:{"md-tag":"md-toolbar","md-elevation":"2"}},[_c('div',{staticClass:"md-toolbar-container"}),_vm._v(" "),_c('div',{staticClass:"md-toolbar-container"},[_c('h2',{staticClass:"md-title"},[_vm._v("Login")])])])],1),_vm._v(" "),_c('md-card-content',{staticClass:"scrolable"},[_c('form',[_c('md-input-container',{class:{ 'md-input-invalid' : _vm.user.hasError}},[_c('label',[_vm._v("Login")]),_vm._v(" "),_c('md-input',{on:{"input":function($event){return _vm.removeError()}},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v(_vm._s(_vm.snack.message))])],1),_vm._v(" "),_c('md-input-container',{class:{ 'md-input-invalid' : _vm.user.hasError},attrs:{"md-has-password":""}},[_c('label',[_vm._v("Senha")]),_vm._v(" "),_c('md-input',{attrs:{"type":"password"},on:{"input":function($event){return _vm.removeError()}},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1),_vm._v(" "),_c('md-button',{staticClass:"md-primary md-raised full",on:{"click":_vm.login}},[_vm._v("\n            Entrar\n            "),(_vm.isRequesting === true)?_c('md-spinner',{staticClass:"md-accent",attrs:{"md-size":20,"md-indeterminate":""}}):_vm._e()],1)],1)])],1),_vm._v(" "),_c('md-snackbar',{ref:"snackbar",attrs:{"md-position":_vm.snack.vertical + ' ' + _vm.snack.horizontal,"md-duration":_vm.snack.duration}},[_c('span',[_vm._v(_vm._s(_vm.snack.message))]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",on:{"click":function($event){return _vm.$refs.snackbar.close()}}},[_vm._v("Ok")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "an13":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  getLocalMessage: function getLocalMessage() {
    return localStorage.getItem("message");
  },

  setLocalMessage: function setLocalMessage(message) {
    localStorage.setItem("message", message);
  },

  removeLocalMessage: function removeLocalMessage() {
    return localStorage.removeItem("message");
  }

});

/***/ }),

/***/ "b2AH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full"},[_c('md-card',[_c('md-card-header',[_c('md-whiteframe',{staticClass:"md-medium",attrs:{"md-tag":"md-toolbar","md-elevation":"2"}},[_c('div',{staticClass:"md-toolbar-container"}),_vm._v(" "),_c('div',{staticClass:"md-toolbar-container"},[_c('h2',{staticClass:"md-title"},[_vm._v("Adicionar Solicitações")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_c('md-button',{staticClass:"md-fab md-fab-cancel"},[_c('md-icon',[_vm._v("clear")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("Cancelar")])],1)],1),_vm._v(" "),_c('md-button',{staticClass:"md-fab md-fab-save",attrs:{"id":"save"},on:{"click":_vm.openSaveDialog}},[_c('md-icon',[_vm._v("done")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("Salvar")])],1)],1)])],1),_vm._v(" "),_c('md-card-content',{staticClass:"scrolable"},[_c('div',{staticClass:"md-subheading"},[_vm._v("\n        "+_vm._s(_vm.issues.created)+"\n      ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-gutter":"16"}},[_c('md-layout',{attrs:{"md-flex":"70"}},[_c('md-input-container',[_c('label',[_vm._v("Título")]),_vm._v(" "),_c('md-textarea',{attrs:{"placeholder":"Padrão: [Cliente] - [Placa]"},model:{value:(_vm.issues.summaryFormat),callback:function ($$v) {_vm.$set(_vm.issues, "summaryFormat", $$v)},expression:"issues.summaryFormat"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"30"}},_vm._l((_vm.issues.summaryOptions),function(value,key){return _c('md-chip',{key:key,staticClass:"align-to-field",attrs:{"md-editable":""},on:{"edit":function($event){return _vm.insertKeyOnSummary(key)}}},[_vm._v("\n            "+_vm._s(value)+"\n          ")])}),1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"center"}},[_c('div',{staticClass:"md-caption"},[_vm._v("\n          "+_vm._s(_vm.exampleMessage)+"\n        ")])]),_vm._v(" "),_c('md-input-container',{class:{ 'md-input-invalid' : _vm.issues.hasDescriptionError && !_vm.issues.description}},[_c('label',[_vm._v("Descrição")]),_vm._v(" "),_c('md-textarea',{attrs:{"required":""},model:{value:(_vm.issues.description),callback:function ($$v) {_vm.$set(_vm.issues, "description", $$v)},expression:"issues.description"}})],1),_vm._v(" "),_vm._l((_vm.issues.vehicleTickets),function(vehicleTicket,i){return _c('md-layout',{key:i,attrs:{"md-gutter":"16"}},[_c('md-layout',{attrs:{"md-flex":""}},[_c('md-input-container',{class:{ 'md-input-invalid' : vehicleTicket.hasPlateError}},[_c('label',[_vm._v("Placa")]),_vm._v(" "),_c('md-autocomplete',{attrs:{"fetch":_vm.findVehiclesByPlateFetch,"print-attribute":'plate',"debounce":700},on:{"selected":_vm.isPlatesInTickets},model:{value:(vehicleTicket.plate),callback:function ($$v) {_vm.$set(vehicleTicket, "plate", $$v)},expression:"vehicleTicket.plate"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v(_vm._s(vehicleTicket.messageError))])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":""}},[_c('md-input-container',{class:{ 'md-input-invalid' : vehicleTicket.hasIssuetypeError && !vehicleTicket.issuetype}},[_c('label',[_vm._v("Motivo")]),_vm._v(" "),_c('md-select',{attrs:{"required":""},on:{"selected":_vm.updateLastSelected},model:{value:(vehicleTicket.issuetype),callback:function ($$v) {_vm.$set(vehicleTicket, "issuetype", $$v)},expression:"vehicleTicket.issuetype"}},_vm._l((_vm.issueTypes),function(issueType){return _c('md-option',{key:issueType,attrs:{"value":issueType}},[_vm._v(_vm._s(issueType))])}),1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"10"}},[_c('md-button',{staticClass:"md-icon-button md-warn align-to-field",on:{"click":function($event){return _vm.removeVehicle(vehicleTicket)}}},[_c('md-icon',[_vm._v("cancel")])],1)],1)],1)}),_vm._v(" "),_c('md-button',{staticClass:"md-primary md-raised",on:{"click":_vm.addVehicle}},[_vm._v("Adicionar Veiculo")])],2)],1),_vm._v(" "),_c('md-snackbar',{ref:"snackbar",attrs:{"md-position":_vm.snack.vertical + ' ' + _vm.snack.horizontal,"md-duration":_vm.snack.duration}},[_c('span',[_vm._v(_vm._s(_vm.snack.message))]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",on:{"click":function($event){return _vm.$refs.snackbar.close()}}},[_vm._v("Ok")])],1),_vm._v(" "),_c('md-dialog',{ref:"wait",attrs:{"md-open-from":"#wait","md-close-to":"#wait"}},[_c('md-dialog-title',[_vm._v("Aguarde ...")]),_vm._v(" "),_c('md-dialog-content',[_c('md-progress',{attrs:{"md-indeterminate":""}})],1)],1),_vm._v(" "),_c('md-dialog',{ref:"save",attrs:{"md-open-from":"#save","md-close-to":"#save"}},[_c('md-dialog-title',[_vm._v("Tem certeza que deseja salvar estes tickets?")]),_vm._v(" "),_c('md-dialog-content'),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){return _vm.closeSaveDialog()}}},[_vm._v("Não")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",on:{"click":function($event){return _vm.saveTickets()}}},[_vm._v("Sim")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cJ1i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_TicketsService__ = __webpack_require__("0EZ5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_AuthService__ = __webpack_require__("SGRL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_LoginInfoService__ = __webpack_require__("AaX6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_file_saver__ = __webpack_require__("t4zo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_datepicker__ = __webpack_require__("trBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_datepicker_index_css__ = __webpack_require__("1QwG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_datepicker_locale_pt_br__ = __webpack_require__("EWRc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_datepicker_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue2_datepicker_locale_pt_br__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DatePicker: __WEBPACK_IMPORTED_MODULE_10_vue2_datepicker__["default"]
  },

  data: function data() {
    return {
      tickets: [],
      seenTicket: {
        fields: {
          created: null,
          customfield_10401: [],
          description: null,
          status: {
            name: null
          },
          reporter: {
            name: null
          }
        }
      },
      linksStatus: {
        expeditionStatus: null,
        configurationStatus: null
      },
      isOpenFilter: false,
      situations: [],
      filter: {
        ticketKey: null,
        situation: null,
        organizationName: null,
        vehiclePlate: null,
        created: [this.getFirstDayOfYear(), new Date()],
        startAt: 0,
        maxResults: 50,
        fields: ["key", "created", "customfield_10401", "customfield_10700", "customfield_10701", "description", "duedate", "issuetype", "reporter", "resolution", "resolutiondate", "status", "summary", "issuelinks"]
      },
      ticketsNumber: 0,
      startAt: 0,
      isRequesting: false,
      createTicketsPath: "/create_tickets"
    };
  },
  created: function created() {
    var _this = this;

    var sessionId = this.$route.query["sessionid"];
    if (sessionId) {
      __WEBPACK_IMPORTED_MODULE_4__services_TicketsService__["a" /* default */].loginWithSessionId(sessionId).then(function (success) {
        var loginInfo = success.body;
        __WEBPACK_IMPORTED_MODULE_8__services_LoginInfoService__["a" /* default */].setLoginInfo(loginInfo);

        __WEBPACK_IMPORTED_MODULE_7__services_AuthService__["a" /* default */].addToken(sessionId);
        _this.findTickets(_this.tickets.length);
        _this.findTicketsSituations();
      });
    } else {
      var authorization = this.$route.query["authorization"];

      if (authorization) {
        __WEBPACK_IMPORTED_MODULE_4__services_TicketsService__["a" /* default */].loginWithAuthorization(authorization).then(function (success) {
          var loginInfo = success.body;
          __WEBPACK_IMPORTED_MODULE_8__services_LoginInfoService__["a" /* default */].setLoginInfo(loginInfo);

          __WEBPACK_IMPORTED_MODULE_7__services_AuthService__["a" /* default */].addToken(authorization);
          _this.findTickets(_this.tickets.length);
          _this.findTicketsSituations();
        });
      } else {
        this.findTickets(this.tickets.length);
        this.findTicketsSituations();
      }
    }

    this.setCreateTicketsUrl();
  },


  methods: {
    validate: function validate() {
      if (!this.filter.created || this.filter.created.length !== 2) {
        alert('O campo "Data de Criação" é obrigatório.');
        return false;
      }
      return true;
    },
    getFirstDayOfYear: function getFirstDayOfYear() {
      var now = new Date();
      return new Date(now.getFullYear(), 0, 1);
    },

    findTickets: function findTickets(startAt) {
      var _this2 = this;

      this.isRequesting = true;
      if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default()(startAt)) {
        startAt = this.startAt;
      }
      this.filter.startAt = startAt;
      this.filter.maxResults = 50;
      this.fields = ["key", "created", "customfield_10401", "customfield_10700", "customfield_10701", "description", "duedate", "issuetype", "reporter", "resolution", "resolutiondate", "status", "summary", "issuelinks"];
      this.filter.start = this.filter.created && this.filter.created[0] && this.getDateFormated(this.filter.created[0]);
      this.filter.end = this.filter.created && this.filter.created[1] && this.getDateFormated(this.filter.created[1]);

      __WEBPACK_IMPORTED_MODULE_4__services_TicketsService__["a" /* default */].searchTickets(this.filter).then(function (success) {
        _this2.isRequesting = false;
        if (startAt === 0) {
          _this2.tickets = [];
        }
        var newTickets = success.body.issues;
        newTickets.forEach(function (issue) {
          issue.fields.created = _this2.getDateFormated(issue.fields.created);
          issue.fields.resolutiondate = _this2.getDateFormated(issue.fields.resolutiondate);
        });
        _this2.tickets = _this2.tickets.concat(newTickets);
        _this2.startAt = _this2.tickets.length;
        _this2.ticketsNumber = success.body.total;
      });
    },

    exportTickets: function exportTickets() {
      var _this3 = this;

      if (this.validate()) {
        this.openWaitDialog();

        var localFilter = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.filter);

        localFilter.fields = ["key", "customfield_10401", "status", "created", "resolution", "resolutiondate", "customfield_10700", "reporter", "summary"];
        localFilter.csvParams = {
          defaultNull: "Indisponível",
          translationFieldsMapping: {
            key: "Código",
            "fields.customfield_10401": "Placa",
            "fields.status.name": "Status",
            "fields.created": "Criação",
            "fields.resolution.name": "Resolução",
            "fields.resolutiondate": "Data de Resolução",
            "fields.customfield_10700.value": "Tipo de Requisição",
            "fields.reporter.name": "Solicitante",
            "fields.summary": "Título"
          }
        };

        __WEBPACK_IMPORTED_MODULE_4__services_TicketsService__["a" /* default */].exportTickets(localFilter).then(function (success) {
          _this3.closeWaitDialog();
          __WEBPACK_IMPORTED_MODULE_9_file_saver___default.a.saveAs(success.bodyText);
        }).catch(function (error) {
          _this3.closeWaitDialog();
          alert(error.body.message);
        });
      }
    },

    findTicketsSituations: function findTicketsSituations() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_TicketsService__["a" /* default */].findTicketsSituations().then(function (success) {
        _this4.situations = success.body;
      });
    },

    applyFilter: function applyFilter(value) {
      this.findTickets(0);
    },

    updateState: function updateState() {
      this.filter.start = this.filter.created && this.filter.created[0] && this.getDateFormated(this.filter.created[0]);
      this.filter.end = this.filter.created && this.filter.created[1] && this.getDateFormated(this.filter.created[1]);
    },

    openFilter: function openFilter() {
      this.isOpenFilter = !this.isOpenFilter;
      if (this.isOpenFilter === false) {
        this.filter.situation = null;
        this.findTickets(0);
      }
    },

    getDateRangeFormated: function getDateRangeFormated(dates) {
      if (dates && dates[0] && dates[1]) {
        __WEBPACK_IMPORTED_MODULE_5_moment_moment___default.a.locale("pt-br");
        return __WEBPACK_IMPORTED_MODULE_5_moment_moment___default()(dates[0]).format("L") + " - " + __WEBPACK_IMPORTED_MODULE_5_moment_moment___default()(dates[1]).format("L");
      }
      return null;
    },
    getDateFormated: function getDateFormated(date) {
      if (date) {
        __WEBPACK_IMPORTED_MODULE_5_moment_moment___default.a.locale("pt-br");
        return __WEBPACK_IMPORTED_MODULE_5_moment_moment___default()(date).format("L");
      }
      return null;
    },


    showTicket: function showTicket(ticket) {
      this.seenTicket = this.normalizeTicket(ticket);

      this.openWaitDialog();

      var linksKeys = this.getTicketLinksKeys(ticket.fields.issuelinks);

      this.findDueDatesByTicketLinksKeys(linksKeys);
    },

    normalizeTicket: function normalizeTicket(ticket) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, ticket, {
        create_date: this.getDateFormated(ticket.create_date),
        resolution_date: this.getDateFormated(ticket.resolution_date),
        schedule_date: this.getDateFormated(ticket.schedule_date),
        expedir_duedate: this.getDateFormated(ticket.expedir_duedate),
        execution_date: this.getDateFormated(ticket.execution_date),
        config_duedate: this.getDateFormated(ticket.config_duedate),
        availability_date: this.getDateFormated(ticket.availability_date),
        updated: this.getDateFormated(ticket.updated),
        hasScheduling: ticket.scheduling_flows && ticket.scheduling_flows.length > 0,
        inSLA: ticket.days_late === 0 ? 'Sim' : 'Não'
      });
    },

    getTicketLinksKeys: function getTicketLinksKeys(issuelinks) {
      if (issuelinks) {
        var links = issuelinks.map(function (link) {
          return link["outwardIssue"]["key"];
        });
        return links.join(",");
      }

      return "";
    },

    findDueDatesByTicketLinksKeys: function findDueDatesByTicketLinksKeys(linksKeys) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_TicketsService__["a" /* default */].getDueDates(linksKeys).then(function (success) {
        _this5.closeWaitDialog();
        _this5.linksStatus = success.body;
        _this5.openShowTicketDialog();
      }, function (error) {
        _this5.closeWaitDialog();
        _this5.linksStatus.expeditionStatus = "Sem previsão";
        _this5.linksStatus.configurationStatus = "Sem previsão";
        _this5.openShowTicketDialog();
      });
    },

    openShowTicketDialog: function openShowTicketDialog() {
      this.$refs.ticketDetails.open();
    },

    closeShowTicketDialog: function closeShowTicketDialog() {
      this.$refs.ticketDetails.close();
    },

    findVehiclesByPlateFetch: function findVehiclesByPlateFetch(query) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (!query.q || query.q === "") {
          resolve([]);
        }
        __WEBPACK_IMPORTED_MODULE_4__services_TicketsService__["a" /* default */].findVehiclesByPlate(query.q).then(function (success) {
          resolve(success.body);
        });
      });
    },

    findOrganizationsByNameFetch: function findOrganizationsByNameFetch(query) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (!query.q || query.q === "") {
          resolve([]);
        }
        __WEBPACK_IMPORTED_MODULE_4__services_TicketsService__["a" /* default */].searchOrganizations(query.q).then(function (success) {
          resolve(success.body);
        });
      });
    },

    clearFilter: function clearFilter() {
      this.filter = {
        situation: null,
        organizationName: null,
        vehiclePlate: null,
        created: null,
        startAt: 0,
        maxResults: 50,
        fields: ["key", "created", "customfield_10401", "customfield_10700", "customfield_10701", "description", "duedate", "issuetype", "reporter", "resolution", "resolutiondate", "status", "summary", "issuelinks"]
      };
      this.applyFilter(0);
    },

    setCreateTicketsUrl: function setCreateTicketsUrl() {
      var loginInfo = __WEBPACK_IMPORTED_MODULE_8__services_LoginInfoService__["a" /* default */].getLoginInfo();
      if (loginInfo.internal === true) {
        this.createTicketsPath = "/create_tickets_internal";
      }
    },

    openWaitDialog: function openWaitDialog() {
      this.$refs.wait.open();
    },

    closeWaitDialog: function closeWaitDialog() {
      this.$refs.wait.close();
    }
  }
});

/***/ }),

/***/ "fPnO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateTickets_vue__ = __webpack_require__("NXZ8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31904820_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateTickets_vue__ = __webpack_require__("b2AH");
function injectStyle (ssrContext) {
  __webpack_require__("UPcg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateTickets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31904820_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateTickets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g3cy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Pie"].extend({
  mixins: [reactiveProp],
  props: ["options"],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
}));

/***/ }),

/***/ "gwjD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_AuthService__ = __webpack_require__("SGRL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_LoginInfoService__ = __webpack_require__("AaX6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },


  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_1__services_AuthService__["a" /* default */].removeToken();
      __WEBPACK_IMPORTED_MODULE_3__services_LoginInfoService__["a" /* default */].removeLoginInfo();
      __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push({ path: '/login' });
    }
  }

});

/***/ }),

/***/ "h5Mi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-layout',{attrs:{"mdAlign":"center"}},[_c('div',{staticClass:"half"},[_c('md-card',[_c('md-card-header',[_c('md-whiteframe',{staticClass:"md-medium",attrs:{"md-tag":"md-toolbar","md-elevation":"2"}},[_c('div',{staticClass:"md-toolbar-container"}),_vm._v(" "),_c('div',{staticClass:"md-toolbar-container"},[_c('h2',{staticClass:"md-title"},[_vm._v("Seleção de Organização do Jira")])])])],1),_vm._v(" "),_c('md-card-content',{staticClass:"scrolable"},[_c('md-input-container',[_c('label',{attrs:{"for":"customer"}},[_vm._v("Organização")]),_vm._v(" "),_c('md-select',{attrs:{"name":"Customer","id":"customer"},on:{"change":_vm.putOrganization},model:{value:(_vm.selectedCustomer),callback:function ($$v) {_vm.selectedCustomer=$$v},expression:"selectedCustomer"}},_vm._l((_vm.customers),function(customer){return _c('md-option',{key:customer.id,attrs:{"value":customer}},[_vm._v(_vm._s(customer))])}),1)],1)],1)],1),_vm._v(" "),_c('md-snackbar',{ref:"snackbar",attrs:{"md-position":_vm.snack.vertical + ' ' + _vm.snack.horizontal,"md-duration":_vm.snack.duration}},[_c('span',[_vm._v(_vm._s(_vm.snack.message))]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",on:{"click":function($event){return _vm.$refs.snackbar.close()}}},[_vm._v("Ok")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j2Eq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('PageScope')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m78x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var urlServer = 'https://api-tickets.trixlog.com';

var baseUrl = urlServer + '/tickets';

/* harmony default export */ __webpack_exports__["a"] = ({
  baseUrl: baseUrl
});

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_TicketsService__ = __webpack_require__("0EZ5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_AuthService__ = __webpack_require__("SGRL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_LocalMessageService__ = __webpack_require__("an13");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_LoginInfoService__ = __webpack_require__("AaX6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      user: {
        username: null,
        password: null,
        hasError: false
      },

      snack: {
        vertical: 'bottom',
        horizontal: 'center',
        duration: 6000,
        message: null
      },
      isRequesting: false
    };
  },
  created: function created() {
    this.snack.message = __WEBPACK_IMPORTED_MODULE_3__services_LocalMessageService__["a" /* default */].getLocalMessage();
  },
  mounted: function mounted() {
    var _this = this;

    if (__WEBPACK_IMPORTED_MODULE_3__services_LocalMessageService__["a" /* default */].getLocalMessage()) {
      setTimeout(function () {
        _this.openSnackMessage();
        __WEBPACK_IMPORTED_MODULE_3__services_LocalMessageService__["a" /* default */].removeLocalMessage();
      }, 1000);
    }
  },


  methods: {
    login: function login() {
      var _this2 = this;

      this.isRequesting = true;
      __WEBPACK_IMPORTED_MODULE_0__services_TicketsService__["a" /* default */].login(this.user).then(function (success) {
        _this2.isRequesting = true;
        var loginInfo = success.body;
        __WEBPACK_IMPORTED_MODULE_4__services_LoginInfoService__["a" /* default */].setLoginInfo(loginInfo);
        __WEBPACK_IMPORTED_MODULE_1__services_AuthService__["a" /* default */].createToken(_this2.user);

        __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push({ path: '/' });
      }, function (error) {
        _this2.isRequesting = false;
        if (error.status === 401) {
          _this2.user.hasError = true;
          _this2.snack.message = error.bodyText;
          _this2.openSnackMessage();
        }
      });
    },

    removeError: function removeError() {
      if (this.user.hasError === true) {
        this.user.hasError = false;
      }
    },

    openSnackMessage: function openSnackMessage() {
      this.$refs.snackbar.open();
    }
  }

});

/***/ }),

/***/ "qJBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full"},[_c('md-card',[_c('md-card-header',[_c('md-whiteframe',{staticClass:"md-medium",attrs:{"md-tag":"md-toolbar","md-elevation":"2"}},[_c('div',{staticClass:"md-toolbar-container"},[_c('h2',{staticClass:"md-title"},[_vm._v("Adicionar Solicitações")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_c('md-button',{staticClass:"md-fab md-fab-cancel"},[_c('md-icon',[_vm._v("clear")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("Cancelar")])],1)],1),_vm._v(" "),_c('md-button',{staticClass:"md-fab md-fab-save",attrs:{"id":"save"},on:{"click":_vm.openSaveDialog}},[_c('md-icon',[_vm._v("done")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("Salvar")])],1)],1),_vm._v(" "),_c('div',{staticClass:"md-toolbar-container"},[_c('h2',{staticClass:"md-subheading sub-head"},[_vm._v(" "+_vm._s(_vm.formattedSummary)+" ")])])])],1),_vm._v(" "),_c('md-card-content',{staticClass:"scrolable"},[_c('md-layout',{attrs:{"md-gutter":""}},[_c('md-layout',{attrs:{"md-gutter":"","md-flex":"100"}},[_c('md-input-container',{class:{ 'md-input-invalid' : _vm.ticketsInfo.hasTicketTypeError && !_vm.ticketsInfo.ticketType}},[_c('label',{attrs:{"for":"reason"}},[_vm._v("Motivo")]),_vm._v(" "),_c('md-select',{attrs:{"required":"","id":"reason"},on:{"selected":_vm.findQuestionsByType},model:{value:(_vm.ticketsInfo.ticketType),callback:function ($$v) {_vm.$set(_vm.ticketsInfo, "ticketType", $$v)},expression:"ticketsInfo.ticketType"}},_vm._l((_vm.ticketTypes),function(name,ticketType){return _c('md-option',{key:ticketType,attrs:{"value":ticketType}},[_vm._v(" \n                            "+_vm._s(name)+" \n                ")])}),1)],1)],1)],1),_vm._v(" "),_vm._l((_vm.ticketsInfo.vehicleTickets),function(vehicleTicket,i){return _c('md-layout',{key:i,attrs:{"md-gutter":"16"}},[_c('md-layout',{attrs:{"md-flex":""}},[_c('md-input-container',[_c('label',[_vm._v("Placa")]),_vm._v(" "),_c('md-autocomplete',{attrs:{"required":"","fetch":_vm.findVehiclesByPlateFetch,"print-attribute":'plate'},on:{"selected":_vm.isPlatesInTickets},model:{value:(vehicleTicket.plate),callback:function ($$v) {_vm.$set(vehicleTicket, "plate", $$v)},expression:"vehicleTicket.plate"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v(_vm._s(vehicleTicket.messageError))])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":""}},[_c('md-input-container',[_c('label',[_vm._v("Organização")]),_vm._v(" "),_c('md-autocomplete',{attrs:{"required":"","fetch":_vm.findOrganizationByNameFetch,"print-attribute":'name'},model:{value:(vehicleTicket.organization.name),callback:function ($$v) {_vm.$set(vehicleTicket.organization, "name", $$v)},expression:"vehicleTicket.organization.name"}})],1)],1),_vm._v(" "),(_vm.isRequesting === true)?_c('md-layout',{attrs:{"md-flex":"10"}},[_c('md-spinner',{staticClass:"align-to-field",attrs:{"md-size":20,"md-indeterminate":""}})],1):_vm._e(),_vm._v(" "),(_vm.ticketsInfo.vehicleTickets.length !== 1)?_c('md-layout',{attrs:{"md-flex":"10"}},[_c('md-button',{staticClass:"md-icon-button md-warn align-to-field",on:{"click":function($event){return _vm.removeVehicle(vehicleTicket)}}},[_c('md-icon',[_vm._v("cancel")])],1)],1):_vm._e()],1)}),_vm._v(" "),(_vm.ticketsInfo.ticketType === 'INSTALL_UNINSTALL')?_c('md-layout',{attrs:{"md-gutter":""}},[_c('md-layout',{attrs:{"md-flex":""}},[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":_vm.addVehicle}},[_vm._v("Adicionar outro veículo")])],1)],1):_vm._e(),_vm._v(" "),_c('md-layout',{attrs:{"md-gutter":""}},[_c('md-layout',{attrs:{"md-flex":""}},[_c('md-input-container',{class:{ 'md-input-invalid' : _vm.ticketsInfo.hasDescriptionError && !_vm.ticketsInfo.description}},[_c('label',[_vm._v("Descrição")]),_vm._v(" "),_c('md-textarea',{attrs:{"required":""},model:{value:(_vm.ticketsInfo.description),callback:function ($$v) {_vm.$set(_vm.ticketsInfo, "description", $$v)},expression:"ticketsInfo.description"}})],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.adictionalQuestions.ticketType)?_c('div',[_c('h2',{staticClass:"md-subheading"},[_vm._v("Informações Adicionais")]),_vm._v(" "),(_vm.ticketsInfo.lastCoordinate.lastTransmissionTime !== null && _vm.ticketsInfo.ticketType === 'TRANSMISSION_FAIL')?_c('div',[_c('br'),_vm._v(" "),_c('span',{staticClass:"md-body-1"},[_vm._v("Última transmissão à "+_vm._s(_vm.ticketsInfo.lastCoordinate.lastTransmissionTime)+" horas")])]):_vm._e(),_vm._v(" "),_c('md-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasBooleanQuestion()),expression:"hasBooleanQuestion()"}]},[_c('md-table-header',[_c('md-table-row',[_c('md-table-head'),_vm._v(" "),_c('md-table-head',[_vm._v("Sim")]),_vm._v(" "),_c('md-table-head',[_vm._v("Não")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.getFieldsByType(_vm.adictionalQuestions.fields, 'BOOLEAN')),function(field,i){return _c('md-table-row',{key:i},[_c('md-table-cell',[_vm._v("\n                "+_vm._s(field.name)+"\n              ")]),_vm._v(" "),_c('md-table-cell',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ticketsInfo.questionsResponses[field.name]),expression:"ticketsInfo.questionsResponses[field.name]"}],attrs:{"type":"radio","name":'g_'+i},domProps:{"value":true,"checked":_vm.ticketsInfo.questionsResponses[field.name] == true,"checked":_vm._q(_vm.ticketsInfo.questionsResponses[field.name],true)},on:{"change":[function($event){return _vm.$set(_vm.ticketsInfo.questionsResponses, field.name, true)},function($event){return _vm.isWrongResponse(field)}]}})]),_vm._v(" "),_c('md-table-cell',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ticketsInfo.questionsResponses[field.name]),expression:"ticketsInfo.questionsResponses[field.name]"}],attrs:{"type":"radio","name":'g_'+i},domProps:{"value":false,"checked":_vm.ticketsInfo.questionsResponses[field.name] == false,"checked":_vm._q(_vm.ticketsInfo.questionsResponses[field.name],false)},on:{"change":[function($event){return _vm.$set(_vm.ticketsInfo.questionsResponses, field.name, false)},function($event){return _vm.isWrongResponse(field)}]}})])],1)}),1)],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.hasStringQuestion())?_c('div',_vm._l((_vm.getFieldsByType(_vm.adictionalQuestions.fields, 'STRING')),function(field,i){return _c('md-input-container',{key:i},[_c('label',[_vm._v(_vm._s(field.name))]),_vm._v(" "),_c('md-input',{model:{value:(_vm.ticketsInfo.questionsResponses[field.name]),callback:function ($$v) {_vm.$set(_vm.ticketsInfo.questionsResponses, field.name, $$v)},expression:"ticketsInfo.questionsResponses[field.name]"}})],1)}),1):_vm._e(),_vm._v(" "),(_vm.hasFileQuestion())?_c('div',_vm._l((_vm.getFieldsByType(_vm.adictionalQuestions.fields, 'FILE')),function(field,i){return _c('md-input-container',{key:i},[_c('label',[_vm._v(_vm._s(field.name))]),_vm._v(" "),_c('md-file',{attrs:{"id":"file"},on:{"selected":function($event){return _vm.encodeFile($event, field.name)}},model:{value:(_vm.ticketsInfo.questionsResponses[field.name]),callback:function ($$v) {_vm.$set(_vm.ticketsInfo.questionsResponses, field.name, $$v)},expression:"ticketsInfo.questionsResponses[field.name]"}})],1)}),1):_vm._e()],1):_vm._e()],2)],1),_vm._v(" "),_c('md-snackbar',{ref:"snackbar",attrs:{"md-position":_vm.snack.vertical + ' ' + _vm.snack.horizontal,"md-duration":_vm.snack.duration}},[_c('span',{staticClass:"md-warn"},[_vm._v(_vm._s(_vm.snack.message))]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",on:{"click":function($event){return _vm.$refs.snackbar.close()}}},[_vm._v("Ok")])],1),_vm._v(" "),_c('md-dialog',{ref:"wait",attrs:{"md-open-from":"#wait","md-close-to":"#wait"}},[_c('md-dialog-title',[_vm._v("Aguarde ...")]),_vm._v(" "),_c('md-dialog-content',[_c('md-progress',{attrs:{"md-indeterminate":""}})],1)],1),_vm._v(" "),_c('md-dialog',{ref:"save",attrs:{"md-open-from":"#save","md-close-to":"#save"}},[_c('md-dialog-title',[_vm._v("Tem certeza que deseja salvar estes tickets?")]),_vm._v(" "),_c('md-dialog-content'),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){return _vm.closeSaveDialog()}}},[_vm._v("Não")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",on:{"click":function($event){return _vm.saveTickets()}}},[_vm._v("Sim")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rq5j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bar"].extend({
  mixins: [reactiveProp],
  props: ["options"],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
}));

/***/ }),

/***/ "sgCA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t32K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageScope_vue__ = __webpack_require__("gwjD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27407e60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageScope_vue__ = __webpack_require__("6VXO");
function injectStyle (ssrContext) {
  __webpack_require__("aAZX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageScope_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27407e60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageScope_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tzNG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PageScope_vue__ = __webpack_require__("t32K");
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  components: {
    PageScope: __WEBPACK_IMPORTED_MODULE_0__components_PageScope_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5035ca17_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("aRa1");
function injectStyle (ssrContext) {
  __webpack_require__("ZgbO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5035ca17_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yoAV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketsList_vue__ = __webpack_require__("cJ1i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d4f5afa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketsList_vue__ = __webpack_require__("1cmR");
function injectStyle (ssrContext) {
  __webpack_require__("S6Wj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d4f5afa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.7baefea93bf7aec39089.js